import { updateSettings } from '@connect-x-app/hybrid-data-access';
import { ApiError, QueryKeys, SettingsItems } from '@connect-x-app/shared-domain-models';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useUpdateSettings = (options?: UseMutationOptions<SettingsItems, ApiError, SettingsItems, SettingsItems>) =>
  useMutation<SettingsItems, ApiError, SettingsItems, SettingsItems>({
    mutationFn: updateSettings,
    mutationKey: [QueryKeys.SETTINGS],
    ...options,
  });
